function isAlgoliaSearch(aiSearch, aiSearchAcctID) {
  return (
    aiSearch === 'Trmt_Developer_AI_Search' ||
    aiSearchAcctID === 'Trmt_Developer_AI_Search_AcctID'
  );
}

export { isAlgoliaSearch };
